/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Thu May 05 2022
*  File : Autoloader.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";

import { AbstractModuleAutoloadManager } from "@api-commons/modularization/AbstractModuleAutoloadManager.js";
import { PushServiceInterface } from "@api-commons/subscriptions/PushServiceInterface.js";

import { CookistSdkGui } from "../gui/CookistSdkGui.js";
import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";
import { SdkGuiController } from "@api-commons/gui/guiControllers/SdkGuiController.js";
import {DefaultGuiServiceInjector} from "@api-commons/gui/serviceInjectors/DefaultGuiServiceInjector.js"
export class CookistAutoloader extends AbstractModuleAutoloadManager {
    
    constructor(
        win: WindowProxy,
        config: PropertyConfig,
        private guiRenderTarget: Element | Document = null
    ) {
        super(win, config);
    }


    public getGui(): Promise<CookistSdkGui> {
        return super.getGui().then(
            g => g as CookistSdkGui
        );
    }

    protected initSdkClient(): Promise<any> {
        return import(/* webpackChunkName: "cookist/com/sdk/sdk-client" */ "./SdkClient.js").then(
            ({ SdkClient }) => {
                return SdkClient(this.configHelper.getOriginal(), this);
            }
             
        );
    }

    protected initSdkServer(): Promise<any> {
        return this.injectScript(this.configHelper.getSdkJsServerUrl(), "fp-sdk-server");
    }

    protected initPushHelper(): Promise<PushServiceInterface> {
        return this.getSdkClient().then(
            (sdk) => {
                return sdk.pushNotificationService;
            }
        );
    }


    protected initGui(): Promise<SdkGuiController> {
        if (this.guiRenderTarget === null) {
            return Promise.reject("GUI Target not set");
        }

        return this.getSdkClient().then(
            sdk => {
                const gui = import(/* webpackChunkName: "cookist/com/sdk/gui" */ './GUI.js');
                return gui.then(
                    ({ GUI }) => {
                        return GUI(
                            this.guiRenderTarget,
                            new DefaultGuiServiceInjector(CatalogueLanguages.en, this.configHelper.getOriginal(), sdk.getStatsCollector())
                        );
                    }
                );

            }
        );
    }


  
}